module.exports = __webpack_public_path__ + "static/img/founder_photo.53f053e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/founder_photo.jpg
// module id = 2Tnj
// module chunks = 1